import React from 'react';
import DataItemCheckbox from '../components/DataItemCheckbox';

export function TransfersCheckboxColumnFormatter(cellContent, disabled = false) {

  return (
    <div className={'d-flex align-items-center justify-content-center'}>
      <DataItemCheckbox
        fieldName={`${cellContent}`}
        inputClassname={'transfers-checkbox'}
        checkboxSize={'transfers-checkbox-size'}
        containerClassname={'d-flex align-items-center justify-content-center'}
        disabled={disabled}
      />
    </div>
  );
}
